// Function to extract video ID from YouTube URL
export const getYouTubeVideoId = (url: string): string | null => {
  // eslint-disable-next-line no-useless-escape
  const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=)([^#\&\?]*).*/
  const match = url.match(regExp)
  return match && match[2].length === 11 ? match[2] : null
}

// Function to get YouTube thumbnail URL
export const getYouTubeThumbnailUrl = (videoId: string): string => {
  return `https://img.youtube.com/vi/${videoId}/0.jpg`
}

export const isYouTubeVideo = (videoUrl: string) =>
  videoUrl.includes("youtube.com") || videoUrl.includes("youtu.be")
